import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import AuthContext from "../hooks/context/AuthContext";
import { Button } from "react-bootstrap";
import { Filter } from "lucide-react";
import { CgMenuRound } from "react-icons/cg";

const Layout = () => {
  const location = useLocation();
  const { id } = useParams();
  const { pathname } = location;
  const isAuthPage = [
    "/login",
    "/registration",
    "/forgot-password",
    "/add-biodata",
    `/edit-biodata/${id}`,
    `/view-biodata/${id}`,
    `/member-view/${id}`,
  ].includes(pathname);
  const isSidebar = [
    "/member-manager",
    "/dashboard",
    "/event-manager",
    "/team-manager",
    "/member-info",
    "/member-detail",
    "/payment-manager",
    "/matrimonial-manager",
    "/suvichar-manager",
    "/matrimonial-post",
    "/employment-manager",
    "/view-biodata",
    "/add-biodata",
    "/suvichar-post",
    `/edit-biodata/${id}`,
    `/view-biodata/${id}`,
    `/member-view/${id}`,
    "/employment-post",
    "/suggestion-manager",
    "/contect-us-manager",
  ].includes(pathname);
  const { user } = useContext(AuthContext);
  const token = localStorage.getItem("token");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  //All STATE

  return (
    <div>
      <Header
        isAuthPage={isAuthPage}
        isSidebar={isSidebar}
        handleSidebar={handleSidebar}
      />

      <main className={token && isSidebar ? "dashboard-panel-after-login" : ""}>
        {/* {token && isSidebar ? (
          <div className="container">
            <Button
              className="px-2 bg-orange border-0 mb-3 ms-auto d-lg-none d-block"
              onClick={() => handleSidebar()}
            >
              <CgMenuRound className="fs-3" />
            </Button>
          </div>
        ) : (
          ""
        )} */}

        <div className={token && isSidebar ? "container d-flex" : ""}>
          {token && isSidebar ? (
            <Sidebar sidebarOpen={sidebarOpen} handleSidebar={handleSidebar} />
          ) : (
            ""
          )}
          <Outlet />
        </div>
      </main>
      {!isAuthPage ? <Footer /> : ""}
    </div>
  );
};

export default Layout;
